// // Simplified for brevity, assume Button.module.css exists similar to Input
// import React from 'react';
// import styles from './Button.module.css'; // Create this css file with .btn class

// const Button = ({ children, onClick, variant = 'primary', disabled }) => (
//   <button 
//     className={`${styles.btn} ${styles[variant]}`} 
//     onClick={onClick} 
//     disabled={disabled}
//   >
//     {disabled ? 'Loading...' : children}
//   </button>
// );
// export default Button;

import React from 'react';
import styles from './Button.module.css';

const Button = ({ 
  children, 
  variant = 'primary', 
  onClick, 
  isLoading = false,
  disabled = false,
  ...props 
}) => (
  <button 
    className={`${styles.btn} ${styles[variant]} ${isLoading ? styles.loading : ''}`} 
    onClick={onClick} 
    disabled={disabled || isLoading}
    aria-busy={isLoading}
    {...props}
  >
    {isLoading ? (
      <>
        <span className={styles.spinner}></span>
        {children}
      </>
    ) : (
      children
    )}
  </button>
);
export default Button;